<div class="product-tile" fxLayout="column" fxLayoutAlign="start center">
    <div class="product-tile__body" fxLayout="column" fxLayoutAlign="start center">
        <div class="product-tile__media" fxLayout="row" fxLayoutAlign="center center">
            <img class="product-tile__image" [src]="sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + product.media.blob)">
        </div>
        <div class="product-tile__title-wrap">
            <h4 class="product-tile__title">{{product.display}}</h4>
        </div>
        <div class="product-tile__description-wrap">
            <p class="product-tile__description">{{product.description}}</p>
        </div>

        <div class="product-tile__badges" fxLayout="column" fxLayoutAlign="start start">
            <div *ngIf="product.type === PRODUCT_TYPES.SimpleSubscription.code">
                <label class="product-tile__badge" *ngIf="product.isGoogle && product.isGoogle">{{ 'INCLUDES_GOOGLE' | translate }}</label>
            </div>
            <div *ngIf="product.type === PRODUCT_TYPES.SimpleSubscription.code">
                <label class="product-tile__badge" *ngIf="product.isFacebook && product.isFacebook">{{ 'INCLUDES_FACEBOOK' | translate }}</label>
            </div>
            <div *ngIf="product.type === PRODUCT_TYPES.SimpleSubscription.code">
                <label class="product-tile__badge" *ngIf="product.isTikTok && product.isTikTok">{{ 'INCLUDES_TIKTOK' | translate }}</label>
            </div>
        </div>
    </div>
    <div class="product-tile__footer">
        <strong class="product-tile__price" *ngIf="product.type === PRODUCT_TYPES.SimpleProduct.code">{{product?.data?.price | currency: 'USD' : 'symbol' :
            '1.0-0'}}</strong>
        <strong class="product-tile__price" *ngIf="product.type === PRODUCT_TYPES.SimpleSubscription.code">{{ 'FROM' | translate }} {{product?.data?.price | currency:'USD' :
            'symbol' : '1.0-0'}} /{{product.data.duration}}</strong>
        <button type="button" class="blue-button">{{ 'SELECT' | translate }}</button>
    </div>
</div>
